export default __webpack_public_path__ + "static/haiyang-a07372bc4bc085b2a86de6fee970bd84.png";